<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <top-nav :page_title="page_title" v-bind:search_query="search"></top-nav>

                <!-- FLASH MESSAGES -->
                <FlashMessage :position="'right bottom'"></FlashMessage>
                <br>

                <!-- Sample Information alter to users-->
                <div v-if="totalSamples !==0" class="alert alert-success alert-dismissible fade show " role="alert">
                  <h4 class="text-center">
                    We have <strong> {{ totalSamples }} </strong> registered samples!!
                  </h4>
                  <br><hr> Expand the search box below
                  <i aria-hidden="true" class="fas fa-hand-point-down menu_icon"></i>
                  to search for your desired samples.

                  <span type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true" @click="clearAlert">&times;</span>
                  </span>
                </div>

                <details>
                  <summary class="pt-3 blue-gradient d-flex justify-content-center white-text" @click="clearAlert">
                    <h5>Search Samples</h5>
                  </summary>
                  <sample-list-view-filter></sample-list-view-filter>
                </details>

                <div v-if="sampleList.length">
                  <!--TOP-PAGINATION-->
                  <v-page :total-row="matchFiltersAndSearch.pg_len" @page-change="pageInfo" align="center"
                          v-model="current"></v-page>
                  <br>
                  <table class="table table-hover">
                      <thead>
                      <tr>
                        <th class="table-header-style" scope="col"> Id</th>
                        <th class="table-header-style" scope="col"> Theme</th>
                        <th class="table-header-style" scope="col"> Sample Code</th>
                        <th class="table-header-style" scope="col"> Sample Type</th>
                        <th class="table-header-style" scope="col"> Animal Species</th>
                        <th class="table-header-style" scope="col"> Location Collected</th>
                        <th class="table-header-style" scope="col"> Available Amount</th>
                        <th class="table-header-style" scope="col"> Actions</th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr :key="sample.id" v-for="(sample, index) in matchFiltersAndSearch.arr">
                          <td> {{ index + 1 }}</td>
                          <td> {{ sample['theme.name'] }}</td>
                          <td> {{ sample.code }}</td>
                          <td> {{ sample['type.name'] }}</td>
                          <td> {{ sample.animal_species }}</td>
                          <td> {{ sample['study_block.name'] }}, {{ sample['study_block.area'] }}</td>

                        <!-- Blur amount available if user is not logged in-->
                          <td>
                            <div :class="{'blurry-text': !isAuth, 'disable-select': !isAuth}">
                              {{ sample.amount }} {{ sample['quantity.id'] }}
                            </div>
                            <small v-if="!isAuth"><em>
                              <router-link to="/register">Sign Up for more info!</router-link></em>
                            </small>
                          </td>

                        <!-- Action Icons -->
                          <td>
                              <!-- View sample icon -->
                              <b-icon
                                      @click="viewSample(self, sample.code)"
                                      class="border border-info rounded" :font-scale="`${font_scale}`"
                                      icon="eye-fill" title="View Sample"
                                      v-b-tooltip.hover variant="info"
                              ></b-icon>
                            &nbsp;
                              <!-- Add sample to cart icon -->
                              <b-icon v-if="isAuth && !sample.inCart"
                                      :id="`add_to_cart_btn_${index}`"
                                      @click="sample.inCart = !sample.inCart && addToCart(sample.code)"
                                      class="border border-info rounded" :font-scale="`${font_scale}`"
                                      icon="cart-plus" title="Add to Cart"
                                      v-b-tooltip.hover variant="info"
                              ></b-icon>
                              <!-- Remove sample from cart icon -->
                              <b-icon v-if="isAuth" style="display: none"
                                        :id="`added_to_cart_btn_${index}`"
                                        @click="removeFromCartBehavior(index, sample.code)"
                                        class="border border-success rounded" :font-scale="`${font_scale}`"
                                        icon="check-circle" title="In Cart"
                                        v-b-tooltip.hover variant="success"
                                ></b-icon>
                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <!--BOTTOM-PAGINATION-->
                  <v-page :total-row="matchFiltersAndSearch.pg_len" align="center" v-model="current"></v-page>
                  <br>
                  <div style="margin: auto;">
                    <loading-progress
                        :hide-background="hideBackground"
                        :indeterminate="indeterminate"
                        :progress="progressPath"
                        :size="size"
                        fillDuration="2"
                        rotate
                        rotationDuration="1"
                    />
                  </div>
              </div>

                <!--SHOW DIV IF LIST IS EMPTY-->
                <div id="empty-sample-list" class="alert alert-danger alert-dismissible fade show" role="alert"
                    v-else-if="initialSearchDone && !sampleList.length">
                  <h4><b><em>No Samples Found!</em></b></h4>
                </div>
            </div>

          <div v-if="isAuth">
            <router-link to='/addsample'><a>
              <b-button class="float_btn" style="border-radius: 50%" variant="primary">
                <span>Add Sample</span> <i class="fas fa-plus-circle menu_icon"></i>
              </b-button>
            </a></router-link>
          </div>
        </div>
    </div>
</template>

<script>
import TopNav from "@/components/TopNav";
import {getLoggedInUser, handleError, pageStartLoader, paginate, viewSample} from "@/utils/util_functions";
import EventBus from "@/components/EventBus";
import {font_scale} from '@/utils/constants';
import {addToCart} from '@/utils/util_functions';
import SampleListViewFilter from "@/components/SampleListViewFilter";
import {sample_resource} from "@/utils/api_paths";
import axios from "axios";
import $ from "jquery";

export default {
  name: "Sample",
  components: {SampleListViewFilter, TopNav},

  data() {
    return {
      page_title: "Samples",
      self: this,

      router_to_add_samples: '/addsample',

      totalSamples: 0,
      filters: [],
      response: [],
      sampleList: [],
      search: '',
      initialSearchDone: false,

      // data for pagination
      current: 1,

      // progressPath
      indeterminate: true,
      hideBackground: true,
      progressPath: 5,
      size: 180,

      // loader-time
      time: 2000,

      isAuth: null, font_scale,
    };
  },

  created() { this.onPageLoad() },

  mounted() {
    /** Listen to the event emitted from the SampleListViewFilter component and update the sample-list*/
    EventBus.$on('sample-data-to-cart', payload=> {
      this.sampleList = payload
      this.initialSearchDone = true

      setTimeout(() => {
        this.haltProgressPath()
        // append variable to track added samples to cart
        for (let i=0; i < this.sampleList.length; i++){
          this.sampleList[i].inCart = false
        }
      }, this.time)
    })

    EventBus.$on('searchQuery', (payload) => {
      this.search = payload
      this.searchData()
    })

    EventBus.$on('filters', (payload) => {
      this.filters = payload
      if (this.filters.length === 0) {
        this.sampleList = this.response
      }
    })

    EventBus.$on('add-to-cart', payload => {
      for (let j=0; j < payload.length; j++){
       for (let i=0; i < this.sampleList.length; i++){
        if (this.sampleList[i].code === payload[j]){
            // add to cart behavior
            this.sampleList[i].inCart = true
            document.getElementById('add_to_cart_btn_'+i).style.display = 'none'
            document.getElementById('added_to_cart_btn_'+i).style.display = 'inline'
        }
      }
      }
    })
  },

  computed: {
    /**
     * function checks for any filters or searches applied to the data and returns filtered/searched list.
     * @returns {null|[]|*}
     */
    matchFiltersAndSearch: function () {
      let searchList = this.search ? this.searchData() : null
      /* sampleList,which is a copy of response, is passed as the data here instead of response to avoid
      mutating response data.*/
      let filteredData = this.filterData(this.sampleList)

      let filterBySampleCode = filteredData.code

      if (searchList !== null) {
        return paginate(searchList)
      } else if (this.filters.length > 1) {

        let lowest = 0;
        for (let i = 1; i < filteredData.length; i++) {
          if ((filteredData[i] < filteredData[lowest]) && filteredData[i].length > 0) lowest = i;
        }
        return paginate(filteredData[lowest]);

      } else if (filterBySampleCode !== null && filterBySampleCode.length > 0) {
        this.sampleList = filterBySampleCode // eslint-disable-line
        this.filterData(filterBySampleCode)
        return paginate(filterBySampleCode)
      }
      return paginate(this.sampleList)
    },
  },

  methods: {
    addToCart, viewSample,

    onPageLoad(){
      let loader = pageStartLoader(this)
      axios.get(sample_resource, {headers: {count: 0}})
        .then((res) => {
            loader.hide()
            this.isAuth = getLoggedInUser()
            this.totalSamples = res.data.message;
        })
        .catch((error) => {
          handleError(this, error, loader)
      });
    },

    clearAlert(){
      // fade-out function
      $(".alert").delay(500).fadeOut("slow", function () { $(this).remove(); });
    },

    // stop&hide progressPath
    haltProgressPath(cont = false, path = 0, size = 0) {
      this.indeterminate = cont
      this.progressPath = path
      this.size = size
    },

    removeFromCartBehavior(i, code){
      // remove from cart formatting
      document.getElementById('add_to_cart_btn_'+i).style.display = 'inline'
      document.getElementById('added_to_cart_btn_'+i).style.display = 'none'
      addToCart(code) // this is called to reverse the add behavior i.e. remove from cart
    },

    pageInfo(info) {
      EventBus.$emit('page-info', {'pgInfo': info, 'pgData': this.sampleList})
    },
    //end of methods for api interaction

    /* Methods associated with searching and filtering of data in the page */
    filterData(data) {
      let filterBySampleCode = this.filters.length
          ? data.filter(sample =>
              this.filters.some(filter => sample.code ? sample.code.toString().match(filter) : null))
          : null

      return {
        'code': filterBySampleCode,
      }
    },

    searchData() {
      return this.sampleList.filter(sample => {
        for (let count = 0; count <= this.sampleList.length; count++) {
          let bySampleCode = sample.code != null
              ? sample.code.includes(this.search.toLowerCase())
              : null

          if (bySampleCode)
            return bySampleCode
        }
      })
    },
    // end-of methods for search and filter
  },
};
</script>
